import { RadioGroup, Radio, FormControlLabel } from '@vapor/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BillItemFragment, ReservationSearchWithRRFragment } from 'src/api/api.generated'
import { ReservationLookup } from 'src/app/components/reservation-lookup/reservation-lookup'
import BillLookup from 'src/app/pages/booking/bill/components/BillLookup'
import { ReferenceType } from '../deposit-split.types'
import { ReservationWithReservedLookup } from 'src/app/components/reservation-lookup/reservation-with-reserved-lookup'
import useLocalizeString from 'src/app/hooks/current-locale/use-localized-string'

enum LookupOptionEnum {
  bill = 'bill',
  reservation = 'reservation',
}

type DepositSplitLookupProps = {
  propertyId: string
  onChange: (reference: { type: ReferenceType; description: string; billId?: string; reservationId?: string; reservedResourceId?: string }) => void
}

export const DepositSplitLookup = (props: DepositSplitLookupProps) => {
  const { t } = useTranslation()
  const localizeString = useLocalizeString()

  const [option, setOption] = useState<LookupOptionEnum>(LookupOptionEnum.bill)
  const [billId, setBillId] = useState<string | null>()

  const onChangeBillHandler = async (bill: BillItemFragment | null) => {
    if (bill) {
      setBillId(bill.id)
      props.onChange({ type: 'bill', description: bill.description, billId: bill.id, reservationId: bill.reservationId?.[0], reservedResourceId: bill.reservedResourceId?.[0] })
    } else {
      setBillId(null)
    }
  }

  const onChangeReservationHandler = (v: ReservationSearchWithRRFragment | null) => {
    if (v?.id) {
      try {
        const { reservationCode } = v
        const ids = v.id.split('#')
        if (ids.length === 2) {
          // split on reservedResource
          const [reservationId, reservedResourceId] = ids
          const reservedResource = v.reservedResources?.find((rr) => rr.id === reservedResourceId)
          const resourceOccupancy = reservedResource?.resourceOccupancies?.[reservedResource?.resourceOccupancies.length - 1]

          const resourceType =
            resourceOccupancy?.assignedResourceType.code ??
            localizeString(resourceOccupancy?.assignedResourceType.customName) ??
            localizeString(resourceOccupancy?.assignedResourceType.name.description)
          const resource = resourceOccupancy?.resource?.code ?? ''

          const description = `${resourceType} ${resource} ${t('pms.accounting.documents.deposit_split.reference_type_reservation')} ${reservationCode}`

          props.onChange({ type: 'reservedResource', description, reservationId, reservedResourceId })
        } else props.onChange({ type: 'reservation', description: reservationCode, reservationId: v.id })
      } catch (error) {
        console.log('Unable to get reservation or reservedResource ID')
      }
    }
  }

  return (
    <div>
      <RadioGroup onChange={(e) => setOption(e.target.value as LookupOptionEnum)} value={option}>
        <FormControlLabel value={LookupOptionEnum.bill} control={<Radio size="small" />} label={t('pms.deposit-split-lookup.bill')} />
        <FormControlLabel value={LookupOptionEnum.reservation} control={<Radio size="small" />} label={t('pms.deposit-split-lookup.reservation')} />
      </RadioGroup>
      {option === LookupOptionEnum.bill && (
        <div>
          <BillLookup propertyId={props.propertyId} value={billId ? { id: billId } : null} onChange={onChangeBillHandler} disableNew passerByOnly />
        </div>
      )}
      {option === LookupOptionEnum.reservation && <ReservationWithReservedLookup propertyId={props.propertyId} onChange={onChangeReservationHandler} />}
    </div>
  )
}
